import { TextField } from '@mui/material';
import { ComponentProps, FC } from 'react';
import { Controller } from 'react-hook-form';

type Props = ComponentProps<typeof TextField> & {
    name: string;
};

export const ControlledInput: FC<Props> = ({ name, label, required, multiline, fullWidth, disabled, ...props }) => {
    return (
        <Controller
            name={name}
            defaultValue=""
            render={({ field: { onChange, value }, fieldState: { error } }) => (
                <TextField
                    className={multiline ? 'controlled-multiline-input' : 'registration-inputs'}
                    label={label}
                    value={value}
                    onChange={onChange}
                    error={!!error}
                    helperText={error ? error.message : null}
                    required={required}
                    id={`${name}-field`}
                    multiline={multiline}
                    rows={multiline ? 3 : undefined}
                    fullWidth={fullWidth}
                    disabled={disabled}
                    {...props}
                />
            )}
        />
    );
};
